import React, { useState } from 'react';
import { C } from '../tokens.js';
import { D } from '../mock-data.js';
import { BkHdr, Badge, Card } from '../components/ui.jsx';

const NOTIFS = [
  { id:'n1', type:'delivery', read:false, time:'6:32 AM', title:'Order delivered 🎉', body:'Your Full Cream Milk + Curd from Nandini Dairy has been delivered.', action:'Track order', icon:'🛵', color:'#dcfce7', tcolor:'#15803d' },
  { id:'n2', type:'booking',  read:false, time:'Yesterday', title:'Booking reminder', body:'Your Hair Wash & Style at Glow & Go Salon is tomorrow at 3:30 PM.', action:'View booking', icon:'✂️', color:'#fce7f3', tcolor:'#be185d' },
  { id:'n3', type:'subscription', read:false, time:'Yesterday', title:'Subscription paused', body:'Your Eggs subscription from Fresh Farms has been paused until 2 Jun.', action:'Manage', icon:'📅', color:'#fef3c7', tcolor:'#d97706' },
  { id:'n4', type:'delivery', read:true,  time:'2 days ago', title:'Out for delivery', body:'Multigrain Bread from Hari Bakery is on its way. Arriving in ~8 min.', action:null, icon:'🛵', color:'#dbeafe', tcolor:'#2563eb' },
  { id:'n5', type:'promo',    read:true,  time:'3 days ago', title:'New vendor nearby 🆕', body:'Sri Krishna Dairy has joined Rekraft in Bandra West. First delivery free!', action:'Explore', icon:'🎁', color:'#e6f7fb', tcolor:'#0cc0df' },
  { id:'n6', type:'subscription', read:true, time:'4 days ago', title:'Smart reorder suggestion', body:'You usually order Eggs every week. Want to set up a weekly subscription?', action:'Set up', icon:'💡', color:'#f0fdf4', tcolor:'#15803d', deepLink:{kind:'subscribe', branchId:'g3', productId:'p303', cadence:'Weekly'} },
  { id:'n7', type:'booking',  read:true,  time:'5 days ago', title:'Review your visit ⭐', body:'How was your Haircut at The Barber Society? Leave a quick review.', action:'Write review', icon:'⭐', color:'#fef3c7', tcolor:'#d97706' },
  { id:'n8', type:'promo',    read:true,  time:'1 week ago', title:'Refer & earn ₹50', body:'Invite a friend to Rekraft. You both get ₹50 off your next order.', action:'Share now', icon:'🎉', color:'#e6f7fb', tcolor:'#0cc0df' },
];

const resolveDeepLink = (link) => {
  if (!link) return null;
  if (link.kind === 'subscribe') {
    const branch = D.branches.grocery.find((b) => b.id === link.branchId);
    const product = branch?.products?.find((p) => p.id === link.productId);
    if (branch && product) return { type:'product', data:{ product, branch, openSubscribeOnMount:true, initialCadence:link.cadence } };
  }
  return null;
};

const TYPE_FILTERS = ['All','Delivery','Booking','Subscription','Promo'];

export const NotificationsScreen = ({goBack, navigate}) => {
  const [notifs, setNotifs] = useState(NOTIFS);
  const [filter, setFilter] = useState('All');

  const unread = notifs.filter(n => !n.read).length;
  const shown = filter === 'All' ? notifs : notifs.filter(n => n.type === filter.toLowerCase());

  const markRead = (id) => setNotifs(ns => ns.map(n => n.id===id ? {...n, read:true} : n));
  const markAllRead = () => setNotifs(ns => ns.map(n => ({...n, read:true})));
  const dismiss = (id) => setNotifs(ns => ns.filter(n => n.id !== id));

  return (
    <div className="fade-in" style={{flex:1, display:'flex', flexDirection:'column'}}>
      <BkHdr title="Notifications" onBack={goBack}
        right={unread > 0 &&
          <button onClick={markAllRead} style={{background:'none', border:'none', color:C.primary, fontSize:12, fontWeight:700, cursor:'pointer'}}>
            Mark all read
          </button>
        }
      />

      {/* Filter chips */}
      <div style={{padding:'12px 20px 0', background:C.bg}}>
        <div style={{display:'flex', gap:8, overflowX:'auto', paddingBottom:14, scrollbarWidth:'none'}}>
          {TYPE_FILTERS.map(f => (
            <button key={f} onClick={()=>setFilter(f)} style={{padding:'7px 16px', borderRadius:100, border:`1.5px solid ${filter===f?C.primary:C.border}`, background:filter===f?C.primary:C.white, color:filter===f?C.white:C.textMed, fontSize:13, fontWeight:600, cursor:'pointer', whiteSpace:'nowrap', flexShrink:0, transition:'all .15s'}}>{f}</button>
          ))}
        </div>
        {unread > 0 && (
          <div style={{display:'flex', alignItems:'center', gap:8, marginBottom:14}}>
            <div style={{width:8, height:8, borderRadius:4, background:C.primary}}/>
            <span style={{fontSize:13, color:C.textMed}}><b style={{color:C.text}}>{unread} unread</b> notification{unread>1?'s':''}</span>
          </div>
        )}
      </div>

      {/* List */}
      <div style={{flex:1, overflowY:'auto', padding:'0 20px 24px', display:'flex', flexDirection:'column', gap:10}}>
        {shown.length === 0 && (
          <div style={{textAlign:'center', padding:'48px 20px'}}>
            <div style={{fontSize:48, marginBottom:12}}>🔔</div>
            <p style={{fontSize:15, fontWeight:700, color:C.text}}>No {filter.toLowerCase()} notifications</p>
            <p style={{fontSize:13, color:C.textMed, marginTop:4}}>You're all caught up!</p>
          </div>
        )}
        {shown.map(n => (
          <div key={n.id} onClick={()=>markRead(n.id)}
            style={{background:n.read?C.white:'#fff8f4', borderRadius:18, padding:'14px 16px', border:`1.5px solid ${n.read?C.border:C.primaryLight}`, cursor:'pointer', transition:'all .15s', position:'relative'}}>
            {!n.read && <div style={{position:'absolute', top:14, right:14, width:8, height:8, borderRadius:4, background:C.primary}}/>}
            <div style={{display:'flex', gap:12, alignItems:'flex-start'}}>
              <div style={{width:44, height:44, borderRadius:13, background:n.color, display:'flex', alignItems:'center', justifyContent:'center', fontSize:22, flexShrink:0}}>{n.icon}</div>
              <div style={{flex:1, minWidth:0}}>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:8, marginBottom:4}}>
                  <p style={{fontSize:14, fontWeight:700, color:C.text, lineHeight:1.3}}>{n.title}</p>
                  <span style={{fontSize:11, color:C.textMed, flexShrink:0, marginTop:1}}>{n.time}</span>
                </div>
                <p style={{fontSize:12, color:C.textMed, lineHeight:1.55, marginBottom: n.action?10:0}}>{n.body}</p>
                {n.action && (
                  <button onClick={(e)=>{ e.stopPropagation(); markRead(n.id); const route = resolveDeepLink(n.deepLink); if (route) navigate(route.type, route.data); }} style={{background:'none', border:'none', padding:0, cursor:'pointer', fontSize:12, fontWeight:700, color:n.tcolor}}>{n.action} →</button>
                )}
              </div>
            </div>
            <button onClick={e=>{e.stopPropagation();dismiss(n.id);}}
              style={{position:'absolute', top:10, right:n.read?10:26, background:'none', border:'none', color:C.textLight, fontSize:16, cursor:'pointer', lineHeight:1, padding:2}}>×</button>
          </div>
        ))}
        <div style={{height:8}}/>
      </div>
    </div>
  );
};
